exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt15[data-v-5c20d372] { margin-top: 15px;\n}\n.mt20[data-v-5c20d372] { margin-top: 20px;\n}\n.btn-sm[data-v-5c20d372] { padding: 6px 12px; font-size: 13px;\n}\n.actions-cell .btn-sm[data-v-5c20d372] { margin-left: 5px;\n}\n.actions-cell .btn-sm[data-v-5c20d372]:first-child { margin-left: 0;\n}\n", ""]);

// exports
